var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import moment from 'moment';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import MemberBalanceManageService from '../../api/MemberBalanceManageService';
var PayCert = (function (_super) {
    __extends(PayCert, _super);
    function PayCert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 0;
        _this.keyword = '';
        _this.shopId = '';
        _this.logTypeSubtract = [2, 4];
        return _this;
    }
    PayCert.prototype.created = function () {
        this.service = MemberBalanceManageService.getInstance();
    };
    PayCert.prototype.mounted = function () {
        this.getList();
    };
    PayCert.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var params = {
            shop_id: this.shopId,
            keyword: this.keyword,
            s_time: '1970-01-01',
            e_time: moment(new Date()).format('YYYY-MM-DD'),
            log_type: 0,
            page: 1,
            start: 0,
            limit: 20
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getDetail(params).then(function (res) {
            var _a = res.data, data = _a.data, total = _a.total;
            var list = (data && data.items) || [];
            _this.listData = list;
            _this.total = total || 0;
        }).finally(function () {
            loadingInstance.close();
        });
    };
    PayCert = __decorate([
        Component
    ], PayCert);
    return PayCert;
}(Vue));
export default PayCert;
